<h2>Portfolio Statistics</h2>
<div class="card-container">
    <fluent-card class="check-summary">
        <div class="card-header">
            <h4>Accounts</h4>
            <div>{{statistics()?.totalCount}}</div>
        </div>

        <div class="card-content">
            <wj-flex-pie [bindingName]="'name'" [binding]="'count'"
                         [itemsSource]="pieData" [palette]="ValidationPiePalette"  [plotMargin]="15">
                <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>
                <wj-flex-pie-data-label content="{count}" [border]="false" [offset]="-25"
                                        [position]="Wijmo.PieLabelPosition.Inside"></wj-flex-pie-data-label>
            </wj-flex-pie>
        </div>
    </fluent-card>

    <fluent-card class="check-summary" style="width: 240px">
        <div class="card-header" style="align-items: flex-start;">
            <h4>Checks</h4>
            <div class="validation-stats-grid">
                <i class="check-icon errors far fa-exclamation-triangle"></i>
                <div class="info-title">Errors</div>
                <div class="info-detail">{{errorsCount()}}</div>

                <i class="check-icon warnings far fa-info-circle"></i>
                <div class="info-title">Warnings</div>
                <div class="info-detail">{{warningsCount()}}</div>
            </div>
        </div>
    </fluent-card>
</div>

<h2>Consistency and Plausibility</h2>
<div class="check-messages-container">
    <table class="checks-table">
        <thead>
            <tr>
                <th class="id">Test ID</th>
                <th class="name">Test Name</th>
                <th class="status">Status</th>
                <th class="count">Count</th>
                <th class="navigation">Nav</th>
            </tr>
        </thead>
        <tbody>
        @for (check of checks(); track check.id) {
            <tr [class.check-navigation-row]="check.count > 0" (dblclick)="onTrowDblClick(check)">
                <td class="id">{{check.id}}</td>
                <td class="name">{{check.name}}</td>
                <td class="status"[innerHTML]="statusIcon(check.severity, check.count)"></td>
                <td class="count">{{check.count}}</td>
                <td class="navigation">
                    @if (check.count > 0) {
                        <fluent-button (click)="onTrowDblClick(check)" appearance="outline" class="small-height">
                        <i class="fas fa-list" title="View affected accounts"></i>
                        </fluent-button>
                    }
                </td>
            </tr>
        }
        </tbody>
    </table>
</div>

<!--
<fluent-button style="position: fixed; right: 5px; bottom: 5px; z-index: 1000;" (click)="startTour()">
    <i class="far fa-sheep"></i>
</fluent-button>
-->
